import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatMenuPanel } from '@angular/material/menu';

type Mode = 'big' | 'standard' | 'long' | 'small' | 'basic' | 'icon' | 'wide' | 'icon-pinned-left';

type Level = 'primary' | 'secondary' | 'accent' | 'warn' | 'tertiary';

@Component({
  selector: 'lib-cdw-button',
  templateUrl: './cdw-button.component.html',
  styleUrls: ['./cdw-button.component.scss'],
  standalone: false,
  host: {
    '[style.--custom-bg-color]': 'isHexColor ? customColor : null',
    '[style.--custom-text-color]': 'isHexColor ? "#ffffff" : null',
  },
})
export class CdwButtonComponent implements OnChanges {
  @Input() mode: Mode = 'standard';

  @Input() level: Level = 'primary';

  @Input() disabled = false;

  @Input() icon = '';

  @Input() type: 'button' | 'submit' | 'reset' = 'button';

  @Input() matMenuTrigger!: MatMenuPanel;

  @Input() customColor?: string;

  @Input() useMatIcon = false;

  @Input() customIconColor?: string;

  @Input() outlined = false;

  @Input() public fontFamily?: string;

  @Input() public fontWeight?: string | number;

  @Input() public fontSize?: string;

  @Input() public fontColor?: string;

  @Input() public outlineColor?: string;

  @Input() public buttonWidth?: string;

  @Input() public alignContent?: 'start' | 'center' = 'center';

  @Input() public iconSize?: string;

  get customStyles(): { [key: string]: string | number } {
    const styles: { [key: string]: string | number } = {};
    if (this.fontFamily) {
      styles['font-family'] = this.fontFamily;
    }
    if (this.fontWeight) {
      styles['font-weight'] = this.fontWeight;
    }
    if (this.fontSize) {
      styles['font-size'] = this.fontSize;
    }
    if (this.fontColor) {
      // biome-ignore lint/complexity/useLiteralKeys: TypeScript requires bracket notation for index signatures (TS4111)
      styles['color'] = this.fontColor;
    }
    if (this.outlineColor) {
      styles['border-color'] = this.outlineColor;
    }
    if (this.buttonWidth) {
      // biome-ignore lint/complexity/useLiteralKeys: TypeScript requires bracket notation for index signatures (TS4111)
      styles['width'] = this.buttonWidth;
    }
    return styles;
  }

  get isHexColor(): boolean {
    return this.customColor?.startsWith('#') ?? false;
  }

  get customColorClass(): string | null {
    return this.isHexColor ? 'hex-color' : this.customColor || null;
  }

  @Output() buttonClick = new EventEmitter<Event>();

  @Output() buttonFocus = new EventEmitter<Event>();

  @Output() buttonBlur = new EventEmitter<Event>();

  public standardIconExists = false;

  public buttonClass = 'primary-standard';

  ngOnChanges(changes: SimpleChanges): void {
    // biome-ignore lint/complexity/useLiteralKeys: TypeScript requires bracket notation for index signatures (TS4111)
    if (changes['level']) {
      this.updateButtonClass();
    }
  }


  onClick(event: Event) {
    if (!this.disabled) {
      this.buttonClick.emit(event);
    }
  }

  onFocus(event: Event) {
    this.buttonFocus.emit(event);
  }

  onBlur(event: Event) {
    this.buttonBlur.emit(event);
  }

  private updateButtonClass(): void {
    this.buttonClass = `${this.level}-${this.mode}`;
  }
}
